import React from 'react';
import styled, { keyframes } from 'styled-components';

const ScrollDownIndicator = () => {
    return (
        <IndicatorContainer>
            <Text>Scroll down</Text>
            <Arrow>↓</Arrow>
        </IndicatorContainer>
    );
}

const IndicatorContainer = styled.div`
  position: absolute;
  left: 50%;
  bottom: 20px;
  transform: translateX(-50%);
  text-align: center;
  font-size: 15px;
  color: #fff;
`;

const Text = styled.p`
  margin: 0;
`;

const blink = keyframes`
  0%, 50%, 100% {
    opacity: 1;
  }
  25%, 75% {
    opacity: 0;
  }
`;

const Arrow = styled.div`
  font-size: 32px;
  animation: ${blink} 2s infinite;
`;

export default ScrollDownIndicator;
